import React, { useState } from 'react';

const s = {
  header: {
    background: 'var(--header-bg)',
    borderBottom: '1px solid rgba(255,255,255,0.15)',
    padding: '0 24px',
    height: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    backdropFilter: 'blur(8px)',
  },
  left: { display: 'flex', alignItems: 'center', gap: 12 },
  logo: {
    height: 32,
    width: 32,
    objectFit: 'contain',
    display: 'block',
    flexShrink: 0,
  },
  divider: {
    width: 1,
    height: 22,
    background: 'rgba(255,255,255,0.3)',
    flexShrink: 0,
  },
  brandName: {
    fontFamily: 'Sora, sans-serif',
    fontSize: 15,
    fontWeight: 700,
    color: 'var(--header-text)',
    letterSpacing: '-0.02em',
  },
  brandSub: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.75)',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    fontWeight: 500,
    marginLeft: 8,
    paddingLeft: 8,
    borderLeft: '1px solid rgba(255,255,255,0.3)',
  },
  right: { display: 'flex', alignItems: 'center', gap: 10 },
  userName: {
    color: 'var(--header-text)',
    fontFamily: 'DM Sans, sans-serif',
    fontSize: 13,
    fontWeight: 600,
    maxWidth: 140,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  btn: (variant) => ({
    background: variant === 'primary'
      ? 'rgba(255,255,255,0.95)'
      : 'rgba(255,255,255,0.15)',
    border: variant === 'primary' ? 'none' : '1px solid rgba(255,255,255,0.3)',
    borderRadius: 'var(--radius-sm)',
    color: variant === 'primary' ? 'var(--header-bg)' : 'var(--header-text)',
    fontFamily: 'DM Sans, sans-serif',
    fontSize: 12,
    fontWeight: 500,
    padding: '5px 12px',
    cursor: 'pointer',
    transition: 'opacity 0.15s',
  }),
};

export default function Header({ activeUser, onImport, onRefresh, getLastRefreshed, onChangePassword, onSignOut, showImport = true }) {
  // Tooltip text is refreshed on hover so the clock never forces a re-render.
  const [refreshTitle, setRefreshTitle] = useState('Refresh');
  const updateRefreshTitle = () => {
    const at = getLastRefreshed && getLastRefreshed();
    setRefreshTitle(at ? `Refresh (updated ${at.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })})` : 'Refresh');
  };

  return (
    <header className="app-header" style={s.header}>
      <div className="app-header-left" style={s.left}>
        <img src="/logo-s-white.png" alt="Syncrea Outreach Tracker" style={s.logo} />
        <div style={s.divider} />
        <span style={s.brandName}>Syncrea</span>
        <span className="hdr-brand-sub" style={s.brandSub}>Outreach Tracker</span>
      </div>
      <div className="app-header-right" style={s.right}>
        <button className="hdr-btn" style={s.btn('ghost')} onClick={onRefresh} onMouseEnter={updateRefreshTitle} onFocus={updateRefreshTitle} title={refreshTitle} aria-label="Refresh">↺<span className="hdr-btn-label"> Refresh</span></button>
        {showImport && <button className="hdr-btn" style={s.btn('ghost')} onClick={onImport} aria-label="Import">⬆<span className="hdr-btn-label"> Import</span></button>}
        <span className="hdr-user" style={s.userName}>{activeUser}</span>
        {onChangePassword && <button className="hdr-btn" style={s.btn('ghost')} onClick={onChangePassword} title={`Change password (signed in as ${activeUser})`} aria-label="Change password">🔑<span className="hdr-btn-label"> Password</span></button>}
        {onSignOut && <button className="hdr-btn" style={s.btn('ghost')} onClick={onSignOut} title="Sign out" aria-label="Sign out">🔒<span className="hdr-btn-label"> Sign out</span></button>}
      </div>
    </header>
  );
}
